export const env = {
  appEnv: import.meta.env.VITE_APP_ENV,
  baseUrl: import.meta.env.VITE_BASE_URL_V2,
  urlPublic: import.meta.env.VITE_URL_PUBLIC,
  siteKeyCloudflare: import.meta.env.VITE_SITE_KEY_CLOUDFLARE,
  urlDoitpayCheckout: import.meta.env.VITE_URL_DOITPAY_CHECKOUT,
  registerEmailMinute: import.meta.env.VITE_REGISTER_EMAIL_MINUTE,
  registerEmailSeconds: import.meta.env.VITE_REGISTER_EMAIL_SECONDS,
  doitpayMerchantIsLive: import.meta.env.VITE_DOITPAY_MERCHANT_ISLIVE,
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  notificationTabStatus: import.meta.env.VITE_DOITPAY_STATUS_NOTIFICATION,
  urlGuidelineMerchant: import.meta.env.VITE_URL_GUIDELINE_MERCHANT,
  sandboxMode: import.meta.env.VITE_SANDBOX_MODE,
  isSandbox: import.meta.env.VITE_IS_SANDBOX,
  productionDashboardUrl: import.meta.env.VITE_PRODUCTION_DASHBOARD_URL,
  sandboxDashboardUrl: import.meta.env.VITE_SANDBOX_DASHBOARD_URL,
  showModeSwitcher: import.meta.env.VITE_SHOW_MODE_SWITCHER,
  use2FAv2: import.meta.env.VITE_USE_2FA_V2,
};
